import React from "react";
import cn from "classnames";
import styles from "./Chip.module.sass";

/** Filtro tipo píldora, con punto de color opcional (sale de Subscriptions). */
const Chip = ({ on, onClick, children, color }) => (
  <button type="button" className={cn(styles.chip, { [styles.chipOn]: on })} onClick={onClick}>
    {color && <span className={styles.dot} style={{ background: color }} />}
    {children}
  </button>
);

export default Chip;
